import { apiClient } from "../../base/ApiClient";

export const getLocationByPostcode = async (postcode) => {
  try {
    const response = await apiClient.get(`/core/postcode-lookup/`, {
      params: { postcode: postcode.trim() }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAddressDetailsById = async (id) => {
    try {
        const response = await apiClient.get('/core/address-retrieve/', {
            params: { id }
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};